/** 与 `public/legal/*.html`（由 `npm run build:legal-html` 从 `doc/*.md` 生成）对应 */

export const LEGAL_DOC_SLUGS = ["user-agreement", "privacy-policy", "subscription-agreement"] as const;

export type LegalDocSlug = (typeof LEGAL_DOC_SLUGS)[number];

export function legalDocHref(slug: LegalDocSlug): string {
  return `/legal/${slug}.html`;
}

export const LEGAL_DOC_HREFS = {
  userAgreement: legalDocHref("user-agreement"),
  privacyPolicy: legalDocHref("privacy-policy"),
  subscriptionAgreement: legalDocHref("subscription-agreement"),
} as const;

export const LEGAL_DOC_PAGE_TITLE: Record<LegalDocSlug, string> = {
  "user-agreement": "用户协议",
  "privacy-policy": "隐私政策",
  "subscription-agreement": "订购服务协议",
};
